/**
 * The status line: "AI assistant" always visible (AI Act art. 50), the hint for this screen, the
 * accessibility button (for whoever needs it, one tap), the language and the connection.
 */
import { useConnection, useMode, useScreen, useSession, useTranslate } from '../../react/hooks';
import { useUiActions } from '../../shell/useUiActions';
import { Icon } from '../../ui-kit/Icon';
import css from './Status.module.css';

export function StatusModule() {
  const t = useTranslate();
  const screen = useScreen();
  const connection = useConnection();
  const mode = useMode();
  const language = useSession((s) => s?.language ?? 'it');
  const recovery = useSession((s) => s?.recovery_level ?? 0);
  const actions = useUiActions();

  const hint = recovery >= 2 ? t('status.recovery') : screen.def?.hint ? t(screen.def.hint) : '';

  return (
    <footer className={css.status}>
      <span className={css.ai}><Icon name="assistant" size={22} />{t('ai.badge')}</span>
      <span className={`${css.hint} ${recovery >= 2 ? css.recovery : ''}`}>{hint}</span>
      <div className={css.tools}>
        <button className={`${css.tool} ${mode.id !== 'none' ? css.on : ''}`} onClick={() => actions.toggleModePicker()}
          aria-label={t('mode.title')}>
          <Icon name="accessibility" size={26} />
        </button>
        <span className={css.lang}>{language.toUpperCase()}</span>
        <span className={`${css.dot} ${css[connection.status]}`} title={t(`status.${connection.status}`)} />
      </div>
    </footer>
  );
}
